import { toLowerCaseGenderFromSingleLetter } from "utils/conversions";
import { GetQuoteResponseBody } from "services/onlineApplicationService";
import { QuoteData } from "store/application/applicationSlice";
import { DTOCoverageOption } from "types/CoverageOptions";

function getSelectedCoverageType(includeFamilyCoverage?: boolean): "Family" | "Individual" | undefined {
    if (includeFamilyCoverage === true) return "Family";
    if (includeFamilyCoverage === false) return "Individual";
    return undefined;
}

export const transformGetQuoteDataToQuoteData = (
    applicantType: "member" | "spouse",
    dtoQuote: GetQuoteResponseBody,
    offerCoverageAmounts: number[]
): QuoteData => {
    const [year, month, day] = dtoQuote.dateOfBirth ?? [0, 0, 0];
    return {
        state: dtoQuote.state!,
        dobMonth: month > 0 ? month.toString().padStart(2, "0") : "",
        dobDay: day > 0 ? day.toString() : "",
        dobYear: year > 0 ? year.toString() : "",
        applicantType: applicantType,
        selectedCoverageAmount: dtoQuote.coverageAmount!,
        selectedCoveragePremium: dtoQuote.premium!,
        hasUsedNicotineLastYear: dtoQuote.hasUsedNicotine ?? false,
        gender: toLowerCaseGenderFromSingleLetter(dtoQuote.gender!) as "male" | "female",
        planCode: dtoQuote.coveragePlan ?? undefined,
        selectedCoverageType: getSelectedCoverageType(dtoQuote.includeFamilyCoverage),
        coverageOptions: mapCoverageOptionsWithPremiums(offerCoverageAmounts, [
            { coverageAmount: +dtoQuote.coverageAmount!, monthlyPremium: dtoQuote.premium! },
        ]),
    };
};

/**
 * Maps coverage options with premiums from API response
 * Only returns options that have matching premiums (filters out non-qualifying coverage amounts)
 */
export const mapCoverageOptionsWithPremiums = (
    offerCoverageAmounts: number[],
    coverageOptions?: DTOCoverageOption[]
): DTOCoverageOption[] => {
    return offerCoverageAmounts.map((amount) => {
        const matchingQuote = coverageOptions?.find((opt) => opt.coverageAmount === amount);
        return {
            coverageAmount: amount,
            monthlyPremium: matchingQuote?.monthlyPremium ?? 0,
        };
    });
};
